import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  updateAssignment,
  deleteAssignment,
  deleteAssignedWorksheet,
} from "../../../assignedWorksheetListSlice";

import { formatDateString } from "../../../../../utils/textUtils";

import Modal from "../../../../../components/Modal";
import CloseButton from "../../../../../components/CloseButton";
import SelectedStudentList from "../../../../../components/complex/SelectedStudentList";
import FilteredStudentList from "../../../../../components/complex/FilteredStudentList";
import TypeSelectionPage from "../../common/TypeSelectionPage/TypeSelectionPage";
import DeleteAssignmentModal from "./DeleteAssignmentModal";

const StudentEditPage = ({ worksheet, onClose }) => {
  const dispatch = useDispatch();
  const { allStudents } = useSelector((state) => state.student);

  const [filteredStudents, setFilteredStudents] = useState(allStudents);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedStudentForDelete, setSelectedStudentForDelete] =
    useState(null);
  const [typeSelectionOpen, setTypeSelectionOpen] = useState(false);

  const handleAddStudents = () => {
    const selectedNewStudent = selectedStudents.filter(
      (student) => student.is_new
    );

    if (selectedNewStudent.length === 0) {
      alert("추가할 학생이 없습니다.");
      onClose();
    } else {
      const data = {
        worksheet_id: worksheet.id,
        students: selectedNewStudent,
      };
      dispatch(updateAssignment({ data }));
      alert(`${selectedNewStudent.length}명의 학생이 추가되었습니다.`);
      onClose();
    }
  };

  const handleFilter = ({ keyword = "", gradeList = [], levelList = [] }) => {
    let studentList = allStudents;

    if (keyword.trim() !== "") {
      studentList = studentList.filter((student) =>
        student.name.includes(keyword)
      );
    }

    studentList = studentList.filter((student) =>
      gradeList.includes(student.grade)
    );

    studentList = studentList.filter((student) =>
      levelList.some((level) => {
        if (level.id === 0) {
          return student.level_list.length === 0;
        }
        return student.level_list.some(
          (studentLevel) => studentLevel.id === level.id
        );
      })
    );

    setFilteredStudents(studentList);
  };

  // 좌측 체크박스 클릭 핸들러
  const handleSelectStudent = (student) => {
    const selectedStudent = selectedStudents.find((s) => s.id === student.id);
    if (selectedStudent) {
      if (!selectedStudent.is_new) {
        setSelectedStudentForDelete(selectedStudent);
        setDeleteModalOpen(true);
      } else {
        setSelectedStudents((prev) => prev.filter((s) => s.id !== student.id));
      }
    } else {
      setSelectedStudents((prev) => [...prev, { ...student, is_new: true }]);
    }
  };

  const confirmDelete = () => {
    const isLastDelete = selectedStudents.length === 1;
    dispatch(
      deleteAssignment({ assignmentId: selectedStudentForDelete.assignment_id })
    );
    setDeleteModalOpen(false);
    if (isLastDelete) {
      dispatch(deleteAssignedWorksheet({ worksheetId: worksheet.id }));
      alert("학생이 모두 제거되어, 해당 문제지는 출제 취소되었습니다.");
      onClose();
    }
  };

  useEffect(() => {
    setSelectedStudents(
      worksheet.assignment_list.map((assignment) => {
        const student = allStudents.find(
          (student) => student.id === assignment.student.id
        );
        return { ...student, is_new: false, assignment_id: assignment.id };
      })
    );
  }, [worksheet]);

  return (
    <Modal>
      <div
        style={{
          background: "#fff",
          padding: "10px 20px",
          borderRadius: "5px",
          width: "1200px",
          height: "600px",
          position: "relative",
          display: "flex",
          gap: "20px",
        }}
      >
        {/* 좌측 리스트 */}
        <div
          style={{
            flex: 3,
            borderRadius: "5px",
          }}
        >
          <div style={{ padding: "10px", color: "black" }}>
            <div style={{ fontSize: "25px", marginBottom: "5px" }}>
              학생 찾기
            </div>
            <div style={{ fontSize: "18px" }}>
              마감 날짜 : {formatDateString(worksheet.closed_at)}
            </div>
          </div>
          <FilteredStudentList
            filteredStudents={filteredStudents}
            selectedStudents={selectedStudents}
            handleSelectStudent={handleSelectStudent}
            handleFilter={handleFilter}
          />
        </div>

        {/* 우측 리스트 */}
        <div
          style={{
            flex: 1.2,
            borderRadius: "5px",
            padding: "10px",
          }}
        >
          {/* X 버튼 */}
          <CloseButton onClick={onClose} />
          {worksheet.type !== "paragraph" && (
            <div
              style={{
                position: "absolute",
                top: "25px",
                right: "80px",
                justifyContent: "center",
                display: "flex",
                alignItems: "center",
                padding: "8px",
                width: "120px",
                color: "white",
                backgroundColor: "#2D2D2D",
                borderRadius: "5px",
              }}
              onClick={() => setTypeSelectionOpen(true)}
            >
              출제 옵션 보기
            </div>
          )}
          <div
            style={{
              marginTop: "50px",
            }}
          >
            <SelectedStudentList
              selectedStudents={selectedStudents}
              handleAddStudents={handleAddStudents}
              handleSelectStudent={handleSelectStudent}
              isEditMode={true}
            />
          </div>
        </div>
      </div>
      {deleteModalOpen && (
        <DeleteAssignmentModal
          studentName={selectedStudentForDelete.name}
          setIsModalOpen={setDeleteModalOpen}
          confirmDelete={confirmDelete}
        />
      )}
      {typeSelectionOpen && (
        <Modal zIndex={200}>
          <TypeSelectionPage
            worksheet={worksheet}
            onClose={() => setTypeSelectionOpen(false)}
            selectedTypes={worksheet.assignment_info}
          />
        </Modal>
      )}
    </Modal>
  );
};

export default StudentEditPage;
